import React from 'react';
import { Play, Pause, Square, SkipForward } from 'lucide-react';

/**
 * Session Controls Component
 * Provides Start/Pause/Resume/Stop/Skip functionality
 */
export default function SessionControls({ 
  sessionStatus, 
  onStart, 
  onPause, 
  onResume, 
  onStop, 
  onSkip,
  canSkip 
}) {
  
  return (
    <div className="bg-white/10 backdrop-blur-md rounded-2xl p-6 mb-6 border border-white/20">
      <div className="flex flex-wrap items-center justify-center gap-4">
        {/* Start Button */}
        {sessionStatus === 'ready' && (
          <button
            onClick={onStart}
            className="flex items-center gap-2 px-8 py-4 bg-gradient-to-r from-green-500 to-emerald-600 hover:from-green-600 hover:to-emerald-700 text-white rounded-xl font-bold text-lg transition-all transform hover:scale-105"
          >
            <Play className="w-6 h-6" />
            Start Practice
          </button>
        )}

        {/* Pause Button */}
        {sessionStatus === 'active' && (
          <>
            <button
              onClick={onPause}
              className="flex items-center gap-2 px-6 py-3 bg-yellow-500 hover:bg-yellow-600 text-white rounded-xl font-bold transition-all"
            >
              <Pause className="w-5 h-5" />
              Pause
            </button>

            {canSkip && (
              <button
                onClick={onSkip}
                className="flex items-center gap-2 px-6 py-3 bg-blue-500 hover:bg-blue-600 text-white rounded-xl font-bold transition-all"
              >
                <SkipForward className="w-5 h-5" />
                Skip Segment
              </button>
            )}
          </>
        )}

        {/* Resume Button */}
        {sessionStatus === 'paused' && (
          <button
            onClick={onResume}
            className="flex items-center gap-2 px-8 py-4 bg-gradient-to-r from-green-500 to-emerald-600 hover:from-green-600 hover:to-emerald-700 text-white rounded-xl font-bold text-lg transition-all transform hover:scale-105"
          >
            <Play className="w-6 h-6" />
            Resume
          </button>
        )}

        {/* Stop Button */}
        {(sessionStatus === 'active' || sessionStatus === 'paused') && (
          <button
            onClick={onStop}
            className="flex items-center gap-2 px-6 py-3 bg-red-500 hover:bg-red-600 text-white rounded-xl font-bold transition-all"
          >
            <Square className="w-5 h-5" />
            Stop
          </button>
        )}
      </div>

      {/* Emergency Stop Note */}
      {(sessionStatus === 'active' || sessionStatus === 'paused') && (
        <p className="text-center text-white/60 text-sm mt-4">
          💡 Tip: You can pause at any time if you need a break
        </p>
      )}
    </div>
  );
}